module.exports = __webpack_public_path__ + "static/Logo-355ae5433ac4897dd8563a8cc4ba5e64.svg";